import {User} from '@firebase/auth-types';

export type CurrentUser = User | null

type Types = 'SET_INITIALIZED' | 'SET_CURRENT_USER'


interface FirebaseState {
  currentUser: CurrentUser
  isInitialized: boolean
}

interface FirebaseAction {
  type: Types
  payload: any
}


export const initialState: FirebaseState = {
  currentUser: null,
  isInitialized: false
};

export default function reducer(state: FirebaseState, action: FirebaseAction): FirebaseState {
  switch (action.type) {
    case 'SET_CURRENT_USER':
      return {...state, currentUser: action.payload, isInitialized: true};
    default:
      return state
  }
}